import { BackendResponse } from "../BackendResponse";
import { withNextApi } from "../nextApiHelpers";
import { EmailVerificationStatus } from "./checkEmailVerificationForCandidate";

export interface PhoneVerificationForCandidateResponse extends BackendResponse {
  item: EmailVerificationStatus;
}

export const checkPhoneVerification =
  withNextApi<PhoneVerificationForCandidateResponse>(
    "/cvp/CvpCheckPhoneVerification"
  );
